import styles from './styles.module.scss';

function AdelphiFormDivider() {
  return <div className={styles.adelphiFormDivider} />;
}

export default AdelphiFormDivider;
